import { UserManager, WebStorageStateStore } from "oidc-client-ts";
import { getConfig } from "~/config";

const userManagerConfig = Object.freeze({
  authority: getConfig().meIdpUrl,
  client_id: "new-viedocme-oidc",
  redirect_uri: `${window.location.origin}/signin-oidc`,
  silent_redirect_uri: `${window.location.origin}/signin-oidc`,
  post_logout_redirect_uri: `${window.location.origin}/signout-oidc`,
  revokeTokensOnSignout: true,
  accessTokenExpiringNotificationTimeInSeconds: 300, //5 mins
  loadUserInfo: true,
  scope:
    "openid profile offline_access viedoc.me.api settings monitor IdentityServerApi",
  userStore: new WebStorageStateStore({ store: window.localStorage }),
});

const userManager = new UserManager(userManagerConfig);

export { userManager, userManagerConfig };
